import { Observable } from 'rxjs/Observable';
import { BaseConfig } from './base-config.service';
import { Injectable } from '@angular/core';

import { GenericHttpService } from './generic-http.service';
import { FormGroup, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { AslibModalComponent, AslibModalService } from '@aslib/modal';

@Injectable()
export class SharedService {
  aslibModal: AslibModalComponent;

  constructor(private readonly http: GenericHttpService<any>,
              private readonly datePipe: DatePipe,
              private baseConfig: BaseConfig,
              private readonly _aslibModalService: AslibModalService,) {
              this.aslibModal = new AslibModalComponent(_aslibModalService);
              }

  public gerarRelatorio(_rota: string, _entidade: any): Observable<any> {
    let retorno: Observable<any> = null;
    retorno = this.http.download(
      this.baseConfig.getBaseUrlApi()
        .concat('/relatorio/')
        .concat(_rota),
      _entidade
    );

    return retorno;
  }

  displayModal(_title: string, _msg: string, _type: string, _warnning = true) {
    const modal = this.aslibModal;
    modal.title = _title;
    modal.text = _msg;
    if (_warnning)
    {
      modal.type =  'warning';
    }
    else{
      modal.type = _type === 'success' ? 'success' : 'error';
    }
    modal.okVisible = true;
    modal.footerVisible = true;
    modal.open();
  }

  public carregarObjetoFormulario(formGroup: FormGroup, model) {
    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        const testeCampo = model[field];
        let ehData = false;

        if (typeof model[field] === 'string' &&
            testeCampo.indexOf('-') !== -1 && testeCampo.indexOf('T') !== -1 && testeCampo.indexOf(':') !== -1) {
            ehData = true;
        }

        if (ehData) {
          control.setValue(this.datePipe.transform(model[field], 'dd/MM/yyyy'));
        } else {
          control.setValue(model[field]);
        }
      } else if (control instanceof FormGroup) {
        this.carregarObjetoFormulario(control, model);
      }
    });
  }

  public carregarFormularioObjeto(formGroup: FormGroup, model) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        const testeCampo = model[field];
        let ehData = false;

        if (typeof model[field] === 'string' &&
            testeCampo.indexOf('-') !== -1 && testeCampo.indexOf('T') !== -1 && testeCampo.indexOf(':') !== -1) {
            ehData = true;
        }

        if (ehData) {
          model[field] = this.datePipe.transform(control.value, 'yyyy-MM-dd');
        } else {
          model[field] = control.value;
        }
      } else if (control instanceof FormGroup) {
        this.carregarObjetoFormulario(control, model);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/shared.service.ts